/* 
    *  You have to include the store in each modal because  
    *  ionic decided they didn't need to access it. This 
    *  also won't show up in your Vue Debugger.
*/

import './styles.scss';
import store from '../../store/';
import router from '../../router.js';

const FixtureListItem = () => import('../fixture-list-item/index.vue');

export default {
    name: 'SearchModal',

    router,
    store,

    components: {
        'fixture-list-item': FixtureListItem
    },

    data() {
        return {
            term: ''
        }
    },

    computed: {
        results() {
            let list = [];

            if (this.term.length > 1) {
                list = this.$store.state.search.search_results;
            }

            return list;
        }
    },

    watch: {
        term() {
            if (this.term.length > 1) {
                this.$store.commit('setSearchTerm', this.term);
            } else {
                this.$store.commit('setSearchTerm', null);
            }

            this.$store.dispatch('getSearchResults', this.term);
        }
    },

    created() {
        if (this.$store.state.search.search_term) {
            this.term = this.$store.state.search.search_term;
        }
    },

    methods: {
        dismissModal() {
            this.$ionic.modalController.dismiss();
        },

        clear() {
            this.term = '';
        },

        navigateTo(url) {
            this.$router.push(url);
            this.$store.commit('resetSearch');
            this.dismissModal();
        }
    }
};